/**
 * 报表管理--地锁统计
 */

import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import RefreshGrid from "@/utils/refreshGrid";
import { Button, Space, Modal } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import { lockStatisticsList, bindDetailList, getCityList } from "@/fetch/fetchApi";

class LockStatistics extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showDetails: false,
    };
    // this.fetchApi = this.fetchApi.bind(this);
    // this.initFormConfig = this.initFormConfig.bind(this);
    // this.handleReset = this.handleReset.bind(this);
    this.initModalFormConfig = this.initModalFormConfig.bind(this);
    this.fetchModalApi = this.fetchModalApi.bind(this);
    // this.modalVisibleAction = this.modalVisibleAction.bind(this);
    this.handleModalReset = this.handleModalReset.bind(this);
  }
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };
  // 页面加载完成，初始化表格与form表单
  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
      modalFormConfig: this.initModalFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    let defaultParam = {
      page: 1,
      pagecount: 10,
      lockId: "",
      lockBrand: "",
      powerStationName: "",
      cityId: "",
      brandTime: `${moment(new Date()).startOf("month").format("YYYY.MM.DD")},${moment(
        new Date(),
      ).format("YYYY.MM.DD")}`,
    };

    // console.log(
    //   "componentDidMount",
    //   "window.LayoutTab:",
    //   window.LayoutTab,
    //   "window.LayoutTab.tabParam:",
    //   window.LayoutTab.tabParam,
    // );

    this.fetchApi(defaultParam);
  }

  /**
   * 获取表格数据前数据格式调整方法，调整后通过组件获取表格数据
   */
  fetchApi = (param) => {
    // console.log("fetchApi entry", param, "this:", this, "formConfig:", this.state.formConfig);
    const newParam = param;
    newParam.cityId = param.cityId ? param.cityId.join(",") : "";
    const tempBrandTime = param.brandTime
      ? [param.brandTime.split(",")[0], param.brandTime.split(",")[1]]
      : ["", ""];
    newParam.brandTimeStart = moment(tempBrandTime[0]).format("YYYY.MM.DD") + " 00:00:00";
    newParam.brandTimeEnd = moment(tempBrandTime[1]).format("YYYY.MM.DD") + " 23:59:59";
    delete newParam.brandTime;
    // console.log("fetchApi out", param);
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "lockStatisticsTable", {
        ...newParam,
      });
    }
  };

  fetchModalApi(param) {
    // console.log(
    //   "fetchModalApi entry",
    //   param,
    //   "this:",
    //   this,
    //   "modalFormConfig:",
    //   this.state.modalFormConfig,
    // );
    const newParam = param;
    newParam.cityId = param.cityId ? param.cityId.join(",") : "";
    // console.log("fetchModalApi out", param);
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.modalFormConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "lockStatisticsModalTable", {
        ...newParam,
      });
    }
  }

  // handleReset = () => {};
  handleModalReset = () => {
    let tempDefaultParam = {
      page: 1,
      pagecount: 10,
      lockId: "",
      lockBrand: "",
      powerStationName: "",
      cityId: "",
    };
    this.fetchModalApi(tempDefaultParam);
  };

  //配置form表单
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入地锁编号",
          param: {
            name: "lockId",
            type: "string",
          },
          labelName: "地锁编号",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入地锁品牌",
          param: {
            name: "lockBrand",
            type: "string",
          },
          labelName: "地锁品牌",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入电站名称",
          param: {
            name: "powerStationName",
            type: "string",
          },
          labelName: "电站名称",
          required: false,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区",
          className: "allshow",
          showCheckedStrategy: "SHOW_PARENT",
          treeCheckable: true,
          sourceApi: getCityList,
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: ["年/月/日", "年/月/日"],
          width: "200px",
          param: {
            name: "brandTime",
            type: "array",
          },
          defaultValue: [moment(new Date()).startOf("month"), moment(new Date())],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 365, // 可选最大天数
          },
          allowClear: false,
          labelName: "统计日期",
          required: true,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "reset",
              icon: "reload",
              text: "重置",
              handler: () => {
                // console.log("reset");
                this.fetchApi({
                  page: 1,
                  pagecount: 10,
                  lockId: "",
                  lockBrand: "",
                  powerStationName: "",
                  cityId: "",
                  brandTime: `${moment(new Date()).startOf("month").format("YYYY.MM.DD")},${moment(
                    new Date(),
                  ).format("YYYY.MM.DD")}`,
                });
              },
            },
            {
              btnType: "submit",
              icon: "search",
              text: "查询",
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "lockStatisticsTable",
      tablePage: "地锁查询",
    };
    return formConfig;
  };

  initModalFormConfig = () => {
    const modalFormConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入地锁编号",
          param: {
            name: "lockId",
            type: "string",
          },
          labelName: "地锁编号",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入地锁品牌",
          param: {
            name: "lockBrand",
            type: "string",
          },
          labelName: "地锁品牌",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入电站名称",
          param: {
            name: "powerStationName",
            type: "string",
          },
          labelName: "电站名称",
          required: false,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区",
          className: "allshow",
          showCheckedStrategy: "SHOW_PARENT",
          treeCheckable: true,
          sourceApi: getCityList,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "reset",
              icon: "reload",
              text: "重置",
              handler: () => {
                // console.log("modal reset");
                this.handleModalReset();
              },
            },
            {
              btnType: "submit",
              icon: "search",
              text: "查询",
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "lockStatisticsModalTable",
      tablePage: "绑定明细",
    };
    return modalFormConfig;
  };

  //配置表格
  init() {
    this.setState({
      tableConfig: {
        tableKey: "lockStatisticsTable",
        tableColumns: [
          {
            name: "地锁编号",
            key: "lockId",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "地锁品牌",
            key: "lockBrand",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },

          {
            name: "电站名称",
            key: "powerStationName",
            colType: "tipCol",
            align: "left",
            render: (value) => {
              if (value) {
                return value;
              } else {
                return "--";
              }
            },
          },
          {
            name: "地区",
            key: "cityName",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "绑定天数",
            key: "bindingDay",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "绑定区间",
            key: "interval",
            colType: "textCol",
            align: "left",
            render: (text) => {
              const str = text.split("\n").join("<br />");
              return <div dangerouslySetInnerHTML={{ __html: str }} />;
            },
          },
          // {
          //   name: "操作",
          //   key: "operate",
          //   colType: "action",
          //   align: "right",
          //   render: (record) => {
          //     return (
          //       <div>
          //         <Button
          //           type="link"
          //           onClick={() => {
          //             this.setState({
          //               showDetails: true,
          //               detailInfo: record,
          //             });
          //           }}>
          //           绑定明细
          //         </Button>
          //       </div>
          //     );
          //   },
          // },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: lockStatisticsList,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
      modalTableConfig: {
        tableKey: "lockStatisticsModalTable",
        tableColumns: [
          {
            name: "地锁编号",
            key: "lockId",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "地锁品牌",
            key: "lockBrand",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "设备编号",
            key: "deviceId",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "电站名称",
            key: "powerStationName",
            colType: "tipCol",
            align: "left",
            render: (value) => {
              if (value) {
                return value;
              } else {
                return "--";
              }
            },
          },
          {
            name: "地区",
            key: "cityName",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "绑定时间",
            key: "bindTime",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
          {
            name: "解绑时间",
            key: "unbindTime",
            colType: "textCol",
            align: "left",
            render: (text) => text || "--",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: bindDetailList,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  }

  // 数据导出
  exportData(type, tableKey) {
    const excelUrl = `${process.env.REACT_APP_API_URL}${
      type === "out" ? "/exportLockStatisticsList.do" : "/exportLockStatisticsBrand.do"
    }`;
    // console.log("exportData", process.env.REACT_APP_API_URL, "excelUrl:", excelUrl);
    const [context, param] = [
      this.context.store.getState().gridsInfo.context[tableKey],
      this.context.store.getState().gridsInfo.context[tableKey].params,
    ];
    // console.log(
    //   "context:",
    //   context,
    //   "param:",
    //   param,
    //   "brandTimeStart:",
    //   param.brandTimeStart,
    //   "brandTimeEnd:",
    //   param.brandTimeEnd,
    // );
    const tempParams = `${param.lockId ? "lockId=" + param.lockId + "&" : ""}${
      param.lockBrand ? "lockBrand=" + param.lockBrand + "&" : ""
    }${param.powerStationName ? "powerStationName=" + param.powerStationName + "&" : ""}${
      param.cityId ? "cityId=" + param.cityId + "&" : ""
    }${param.brandTimeStart ? "brandTimeStart=" + param.brandTimeStart.trim() + "&" : ""}${
      param.brandTimeEnd ? "brandTimeEnd=" + param.brandTimeEnd.trim() : ""
    }
    `;
    // console.log("tempParams:", tempParams);
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${tempParams}`);
    // console.log("download:", ele.download);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${tempParams}`);
    // console.log("href:", ele.href);
    // ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: "#f0f2f5",
        }}
        //   className="sc-page-content electrical-loss-page"
      >
        <div
          className="page-toolbar"
          style={{
            backgroundColor: "#fff",
            padding: "8px 0px 16px",
          }}>
          <div className="form-box">
            <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
          </div>
        </div>
        <div
          // className="page-panel"
          style={{ marginTop: "40px", padding: "20px", backgroundColor: "#fff" }}>
          <Space>
            <Button
              type="primary"
              onClick={(e) => {
                this.exportData("out", "lockStatisticsTable");
              }}>
              导出
            </Button>
            <Button
              type="primary"
              onClick={() => {
                this.setState(
                  {
                    showDetails: true,
                  },
                  () => {
                    // console.log("000 modalFormConfig:", this.state.modalFormConfig);
                    this.handleModalReset();
                  },
                );
              }}>
              绑定明细
            </Button>
          </Space>
          <ScGridTable
            config={this.state.tableConfig}
            style={{
              marginTop: 20,
              padding: 0,
            }}
          />
        </div>
        <Modal
          width={1000}
          title="绑定明细"
          centered
          visible={this.state.showDetails}
          closable={true}
          maskClosable={false}
          destroyOnClose={true}
          onCancel={() => {
            this.setState({
              showDetails: false,
            });
          }}
          footer={false}>
          <div>
            <div
              className="page-toolbar"
              style={{
                backgroundColor: "#fff",
                padding: "8px 0px 16px",
              }}>
              <div className="form-box">
                <FormCore formConfig={this.state.modalFormConfig} fetchApi={this.fetchModalApi} />
              </div>
            </div>
            <div>
              <Space>
                <Button
                  type="primary"
                  onClick={() => this.exportData("entry", "lockStatisticsModalTable")}>
                  导出
                </Button>
              </Space>
              <ScGridTable
                config={this.state.modalTableConfig}
                style={{
                  marginTop: 20,
                  padding: 0,
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default LockStatistics;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/lockStatistics.js